"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const setControlByPath = ({ control, path, controlToSet, }) => {
    if (path.length === 0) {
        return controlToSet;
    }
    const { controls } = control;
    const [currentIndex, ...restOfPath] = path;
    return Object.assign(Object.assign({}, control), { controls: controls && controls.map((controlChild, childIndex) => {
            if (childIndex === currentIndex) {
                return setControlByPath({
                    control: controlChild,
                    path: restOfPath,
                    controlToSet,
                });
            }
            return controlChild;
        }) });
};
exports.default = setControlByPath;
